import React from 'react';
import { Users } from 'react-feather';
import cn from 'classnames';
import { Text, TEXT_VARIANTS, TEXT_COLORS } from 'ui/Typography';
import { Icon } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';
import CopyLink from 'components/shared/CopyLink';
import QuestionPrompt from 'components/Practice/Learner/QuestionPrompt';
import Circle from './Circle';

const RolePlayLearner = ({
  title,
  scenario,
  goal,
  partner,
  partnerLink,
  criteria,
  required,
  domId,
  labelErrorClass,
}) => {
  const hasCriteria = criteria.length > 0;
  return (
    <article id={domId}>
      <div className="bdrs-base PracticeQuestion pb-24 mb-70 ws-pw">
        <div
          className={cn(
            'bdrs-base border-bottom-0 border-top border-gray-lighter pl-32 pr-32 pb-24',
            {
              'pt-16': required,
              'pt-32': !required,
            },
          )}
        >
          <div className="d-f jc-sb fw-w mb-32 ai-c">
            <div className="d-f as-fe">
              <Icon name="theater_masks" className="h-30 w-30" />
              <Text className="pl-10" variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                {t('questions.question.role_play.title')}
              </Text>
            </div>
            <div className="d-f fd-c">
              {required && (
                <span
                  data-behavior="required_question"
                  className={cn(
                    'Label Label-required QuestionElement-label as-fe',
                    labelErrorClass,
                  )}
                >
                  <Icon name="required" className="mr-4" />
                  {t('common.required')}
                </span>
              )}
              <div className="d-f">
                <Text
                  className="bg-secondary bdrs-30 p-4"
                  variant={TEXT_VARIANTS.TAG_BOLD_ON_DARK}
                  color={TEXT_COLORS.ON_SECONDARY}
                >
                  <div className="d-f fd-r pl-4 pr-4 pt-2px pb-2px ai-c">
                    <Users size="15" className="pr-4" />
                    {t('questions.question.role_play.partner_required')}
                  </div>
                </Text>
              </div>
            </div>
          </div>
          <hr className="border-midnight-20" />
          <div className="d-f w-fill jc-sb ai-fe fw-w">
            <div className={cn({ 'mb-32 fz-32 pt-16 wb-bw': title })}>
              {title}
              <div />
            </div>
          </div>
          <Text className="mt-0 mb-32" variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
            {t('questions.question.role_play.scenario')}
          </Text>
          <div className="mb-32 minh-50">
            <span className="mt-0 mb-32" />
            {scenario}
          </div>
          <Text className="mt-0" variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
            {t('questions.question.role_play.goal')}
          </Text>
          <div className="minh-50">{goal}</div>
        </div>
        <div>
          {hasCriteria ? (
            <QuestionPrompt criteria={criteria} />
          ) : (
            <hr className="mb-32 mt-0 border-gray-light" />
          )}
        </div>
        <div className="px-32 wb-bw">
          <div className="mb-32 d-f fd-r ai-b">
            <Circle>1</Circle>
            <div className="d-f fd-c">
              <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                {t('questions.question.role_play.partner')}
              </Text>
              <Text variant={TEXT_VARIANTS.BODY} className="minh-30">
                {partner}
              </Text>
            </div>
          </div>
          <div className="mb-32 d-f fd-r ai-b">
            <Circle>2</Circle>
            <div className="d-f fd-c">
              <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                {t('questions.question.role_play.send_guide_to_partner')}
              </Text>
              <CopyLink
                link={partnerLink}
                className="fz-16 p-12 py-8 mh-36 minw-200 lh-20"
                copyText={t('common.copy_link')}
                useIcon={false}
              />
            </div>
          </div>
          <div className="d-f fd-r mb-32 ai-b">
            <Circle>3</Circle>
            <div className="d-f fd-c">
              <div className="d-f">
                <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD} className="as-b">
                  {t('questions.question.role_play.instructions')}
                </Text>
                <InfoTooltip
                  isReactFeatherIcon
                  className="pl-4 mt-4 tooltip-fixedWidth"
                  tooltip={t('questions.question.role_play.tooltip')}
                />
              </div>
              <Text variant={TEXT_VARIANTS.BODY}>
                {t('questions.question.role_play.what_to_expect')}
              </Text>
            </div>
          </div>
          <div className="mb-32 d-f fd-r">
            <Circle>4</Circle>
            {required ? (
              <div className="d-f fd-c">
                <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                  {t('questions.question.role_play.title_email')}
                </Text>
                <Text variant={TEXT_VARIANTS.BODY}>
                  {t('questions.question.role_play.title_email_required')}
                </Text>
              </div>
            ) : (
              <div className="d-f fd-c">
                <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                  {t('questions.question.role_play.title_email')}
                </Text>
              </div>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};
export default props => <RolePlayLearner {...props} />;
